import type { Game } from '../game/state';
import { el } from './dom';

/** Zifferntastatur mit Restanzeige je Ziffer. */
export class KeypadView {
  private readonly keys: HTMLButtonElement[] = [];

  constructor(
    private readonly root: HTMLElement,
    onDigit: (digit: number) => void,
  ) {
    for (let d = 1; d <= 9; d++) {
      const key = el('button', { class: 'key', type: 'button', 'data-digit': String(d), 'aria-label': `Ziffer ${d}` }, [
        String(d),
      ]);
      key.append(el('span', { class: 'left' }));
      this.keys.push(key);
      this.root.append(key);
    }

    this.root.addEventListener('click', (event) => {
      const target = (event.target as HTMLElement).closest<HTMLButtonElement>('.key');
      if (!target) return;
      onDigit(Number(target.dataset.digit));
    });
  }

  render(game: Game, showRemaining: boolean): void {
    for (let d = 1; d <= 9; d++) {
      const key = this.keys[d - 1];
      const remaining = 9 - game.countDigit(d);
      const label = key.lastElementChild as HTMLSpanElement;
      label.textContent = showRemaining && remaining > 0 ? String(remaining) : '';
      key.classList.toggle('done', remaining <= 0);
    }
  }
}
